import React from "react";
import { Link } from 'react-router-dom';
import logo from '../../assets/A-logomain2.png';

export default function AdminNavbar() {
  return (
    <nav className="w-full bg-[#EBE0CF] text-white p-4 md:px-8 flex justify-between items-center shadow-lg">
      
      {/* Left: Logo */}
      <div className="flex items-center">
        <Link to="/">
          <img
          src={logo}
          alt="Ayusanjivani Logo"
          className="h-16 w-auto object-contain"
          style={{
            transition: 'filter 0.3s ease-in-out'
                }}
              />
        </Link>
      </div>

      {/* Right: Profile / Logout */}
      <div className="flex space-x-4">
        <button className="px-8 py-4 from text-green-900 to hover:text-green-300 transition font-medium">Profile</button>
        <button className="px-8 py-4 from text-green-900 to  hover:text-green-300 transition font-medium">Logout</button>
      </div>

    </nav>
  );
}